const FeaturesSection = () => {
    return (
      <section style={{ padding: '60px 20px', backgroundColor: '#fff' }}>
        <div
          style={{
            maxWidth: '1200px',
            margin: '0 auto',
            display: 'flex',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: '20px',
          }}
        >
          <FeatureCard
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                fill="none"
                stroke="#1a237e"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                viewBox="0 0 24 24"
              >
                <path d="M20 6L9 17l-5-5" />
              </svg>
            }
            title="Cumplimiento legal"
            description="Evita sanciones y mantén tus anuncios activos en plataformas como Airbnb o Booking."
          />
  
          <FeatureCard
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                fill="none"
                stroke="#1a237e"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                viewBox="0 0 24 24"
              >
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="16" x2="12" y2="12" />
                <line x1="12" y1="8" x2="12" y2="8" />
              </svg>
            }
            title="Asesoramiento gratuito"
            description="Te guiamos en todo el proceso sin coste y sin letra pequeña."
          />
  
          <FeatureCard
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                fill="none"
                stroke="#1a237e"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                viewBox="0 0 24 24"
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>
            }
            title="Trámite fácil"
            description="Documentación clara, proceso rápido y soporte en todo momento."
          />
        </div>
      </section>
    );
  };
  
  type FeatureCardProps = {
    icon: React.ReactNode;
    title: string;
    description: string;
  };
  
  const FeatureCard = ({ icon, title, description }: FeatureCardProps) => {
    return (
      <div
        style={{
          flex: '1 1 300px',
          border: '1px solid #e0e0e0',
          borderRadius: '12px',
          padding: '32px',
          textAlign: 'center',
          boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
          backgroundColor: '#fff',
        }}
      >
        <div
          style={{
            width: '56px',
            height: '56px',
            borderRadius: '50%',
            backgroundColor: '#f5f7ff',
            margin: '0 auto 20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {icon}
        </div>
        <h3 style={{ fontSize: '1.1rem', fontWeight: '600', marginBottom: '12px', color: '#000' }}>
          {title}
        </h3>
        <p style={{ fontSize: '0.95rem', color: '#555', lineHeight: '1.5' }}>{description}</p>
      </div>
    );
  };
  
  export default FeaturesSection;
  